module.exports = __webpack_public_path__ + "img/BW.b3272f19.svg";